<div class="dashboard-layout">
  <app-web-analytics-filters />
  <section class="wa-outlet-host">
    <router-outlet />
  </section>
</div>
